module.exports = __webpack_public_path__ + "img/ic_step.3666ea1d.svg";